import { moveToFolder } from 'owa-locstrings/lib/strings/movetofolder.locstring.json';
import { flag } from 'owa-locstrings/lib/strings/flag.locstring.json';
import { pin } from 'owa-locstrings/lib/strings/pin.locstring.json';
import { archive } from 'owa-locstrings/lib/strings/archive.locstring.json';
import { deleteItem } from 'owa-locstrings/lib/strings/deleteitem.locstring.json';
import { itemHeaderLightsOn } from 'owa-locstrings/lib/strings/itemheaderlightson.locstring.json';
import { showInImmersiveReader } from 'owa-locstrings/lib/strings/showinimmersivereader.locstring.json';
import { itemHeaderTranslate } from 'owa-locstrings/lib/strings/itemheadertranslate.locstring.json';
import { itemHeaderPrint } from 'owa-locstrings/lib/strings/itemheaderprint.locstring.json';
import { createRule } from 'owa-locstrings/lib/strings/createrule.locstring.json';
import { itemHeaderBlock } from 'owa-locstrings/lib/strings/itemheaderblock.locstring.json';
import { itemHeaderMarkAsJunk } from 'owa-locstrings/lib/strings/itemheadermarkasjunk.locstring.json';
import { assignPolicyMenuItemName } from 'owa-locstrings/lib/strings/assignpolicymenuitemname.locstring.json';
import { itemHeaderFlag } from 'owa-locstrings/lib/strings/itemheaderflag.locstring.json';
import { markAsUnread } from 'owa-locstrings/lib/strings/markasunread.locstring.json';
import { popoutsOpenInNewWindow } from 'owa-locstrings/lib/strings/popoutsopeninnewwindow.locstring.json';
import { reportAbuse } from 'owa-locstrings/lib/strings/reportabuse.locstring.json';
import { itemHeaderForward } from 'owa-locstrings/lib/strings/itemheaderforward.locstring.json';
import { itemHeaderReplyAll } from 'owa-locstrings/lib/strings/itemheaderreplyall.locstring.json';
import { itemHeaderReply } from 'owa-locstrings/lib/strings/itemheaderreply.locstring.json';
import { composeProtectButton } from 'owa-locstrings/lib/strings/composeprotectbutton.locstring.json';
import { sensitivityMenuText } from 'owa-locstrings/lib/strings/sensitivitymenutext.locstring.json';
import { switchToPlainTextMenuItem } from 'owa-locstrings/lib/strings/switchtoplaintextmenuitem.locstring.json';
import { showMessageOptions } from 'owa-locstrings/lib/strings/showmessageoptions.locstring.json';
import { setImportance } from 'owa-locstrings/lib/strings/setimportance.locstring.json';
import { showFrom } from 'owa-locstrings/lib/strings/showfrom.locstring.json';
import { insertSignature } from 'owa-locstrings/lib/strings/insertsignature.locstring.json';
import { saveDraft } from 'owa-locstrings/lib/strings/savedraft.locstring.json';
import { formattingOptionsTooltip } from 'owa-locstrings/lib/strings/formattingoptionstooltip.locstring.json';
import {
    emojiTooltip,
    itemHeaderLike,
    itemHeaderReplyByMeeting,
    itemHeaderDelete,
    itemHeaderAddToSafeSenders,
    itemHeaderMarkAsPhishing,
    itemHeaderViewMessageSource,
    itemHeaderViewMessageDetails,
    none,
    readUnread,
    replyByImSurfaceActionLabel,
    replyAllByImSurfaceActionLabel,
    toggleAmpLabel,
    toggleDarkCompose,
} from './getDisplayNameFromKey.locstring.json';
import { attachTooltip } from 'owa-locstrings/lib/strings/attachtooltip.locstring.json';
import { accCheckerMenuItemText } from 'owa-locstrings/lib/strings/acccheckermenuitemtext.locstring.json';
import { insertPicturesInlineTooltip } from 'owa-locstrings/lib/strings/insertpicturesinlinetooltip.locstring.json';
import loc, { format } from 'owa-localize';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

import { ComposeActionKey, ReadActionKey, HoverActionKey } from 'owa-outlook-service-options';

export const DIVIDER_DISPLAY_NAME = '-';

export function getComposeActionDisplayName(key: ComposeActionKey): string {
    switch (key) {
        case 'AddAttachment':
            return loc(attachTooltip);
        case 'AddInlineImage':
            return loc(insertPicturesInlineTooltip);
        case 'AddEmoji':
            return loc(emojiTooltip);
        case 'ToggleRibbon':
            return loc(formattingOptionsTooltip);
        case 'SaveDraft':
            return loc(saveDraft);
        case 'InsertSignature':
            return loc(insertSignature);
        case 'ShowFrom':
            return loc(showFrom);
        case 'SetImportance':
            return loc(setImportance);
        case 'ShowMessageOptions':
            return loc(showMessageOptions);
        case 'SwitchBodyType':
            return loc(switchToPlainTextMenuItem);
        case 'SensitivityMenu':
            return loc(sensitivityMenuText);
        case 'ProtectMessage':
            return loc(composeProtectButton);
        case 'AccChecker':
            return loc(accCheckerMenuItemText);
        case 'ToggleDarkCompose':
            return loc(toggleDarkCompose);
        default:
            return '';
    }
}

export function getReadActionDisplayName(key: ReadActionKey): string {
    switch (key) {
        case 'LikeUnlike':
            return loc(itemHeaderLike);
        case 'Reply':
            return loc(itemHeaderReply);
        case 'ReplyAll':
            return loc(itemHeaderReplyAll);
        case 'Forward':
            return loc(itemHeaderForward);
        case 'ReplyByMeeting':
            return loc(itemHeaderReplyByMeeting);
        case 'ReportAbuse':
            return loc(reportAbuse);
        case 'Popout':
            return loc(popoutsOpenInNewWindow);
        case 'Delete':
            return loc(itemHeaderDelete);
        case 'MarkReadUnread':
            return loc(markAsUnread);
        case 'FlagUnflag':
            return loc(itemHeaderFlag);
        case 'AssignPolicy':
            return loc(assignPolicyMenuItemName);
        case 'AddToSafeSenders':
            return loc(itemHeaderAddToSafeSenders);
        case 'MarkJunkNotJunk':
            return loc(itemHeaderMarkAsJunk);
        case 'MarkAsPhishing':
            return loc(itemHeaderMarkAsPhishing);
        case 'Block':
            return format(loc(itemHeaderBlock), '');
        case 'CreateRule':
            return loc(createRule);
        case 'Print':
            return loc(itemHeaderPrint);
        case 'Translate':
            return loc(itemHeaderTranslate);
        case 'ShowInImmersiveReader':
            return loc(showInImmersiveReader);
        case 'ViewMessageSource':
            return isConsumer()
                ? loc(itemHeaderViewMessageSource)
                : loc(itemHeaderViewMessageDetails);
        case 'ToggleDarkMode':
            return loc(itemHeaderLightsOn);
        case 'ReplyByIM':
            return loc(replyByImSurfaceActionLabel);
        case 'ReplyAllByIM':
            return loc(replyAllByImSurfaceActionLabel);
        case 'ToggleAmp':
            return loc(toggleAmpLabel);
        default:
            return '';
    }
}

export function getHoverActionDisplayName(key: HoverActionKey): string {
    switch (key) {
        case 'None':
            return loc(none);
        case 'Delete':
            return loc(deleteItem);
        case 'Archive':
            return loc(archive);
        case 'PinUnpin':
            return loc(pin);
        case 'ReadUnread':
            return loc(readUnread);
        case 'FlagUnflag':
            return loc(flag);
        case 'Move':
            return loc(moveToFolder);
        default:
            return '';
    }
}
